import { useState, useEffect } from "react";

export default function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // SSR-захист: перевіряємо, що window існує
    if (typeof window === "undefined") return;

    // Ловимо подію beforeinstallprompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      console.log("🔥 beforeinstallprompt fired");
    };
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    // Ловимо подію appinstalled
    const handleAppInstalled = () => {
      setIsInstalled(true);
      console.log("✅ App installed");
    };
    window.addEventListener("appinstalled", handleAppInstalled);

    // Очистка слухачів при демонтажі
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  // Функція для показу prompt користувачу
  const promptInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log("📲 Вибір користувача:", outcome);
    setDeferredPrompt(null);
    if (outcome === "accepted") setIsInstalled(true);
    return outcome;
  };

  const canInstall = !!deferredPrompt && !isInstalled;

  return { canInstall, promptInstall };
}
